import Vue from 'vue';

import AddEdit from '@/components/AddEdit.vue'
Vue.component('AddEdit', AddEdit);


import CommonList from '@/components/CommonList.vue'
Vue.component('CommonList', CommonList);

import ShowItem from '@/components/ShowItem.vue'
Vue.component('ShowItem', ShowItem);

import DataDic from '@/components/DataDic.vue'
Vue.component('DataDic', DataDic);


import RemoteSelect from '@/components/RemoteSelect.vue'
Vue.component('RemoteSelect', RemoteSelect);

import GroupTree from '@/components/GroupTree.vue'
Vue.component('GroupTree', GroupTree)

import EmptyComponent from '@/components/EmptyComponent.vue'
Vue.component('EmptyComponent', EmptyComponent)


import MyCheckbox from '@/components/MyCheckbox.vue'
Vue.component('MyCheckbox', MyCheckbox)

import StationSelect from '@/components/OrgSelect.vue'
Vue.component('StationSelect', StationSelect)

import RemoteSelectValueLable from '@/components/RemoteSelectValueLable.vue'
Vue.component('RemoteSelectValueLable', RemoteSelectValueLable)

import CascaderSelect from '@/components/CascaderSelect.vue'
Vue.component('CascaderSelect', CascaderSelect)

import DateRangePicker from '@/components/DateRangePicker.vue'
Vue.component('DateRangePicker', DateRangePicker)

